import {
  Box
} from '@mui/material'

import React from 'react'

import Sprite from 'src/components/common/Sprite'
import SpotLight from './SpotLight'

const colorTransitions = {
  transition: 'color .2s, background-color .2s',
  transitionTimingFunction: 'ease-out'
}

const container = {
  ...colorTransitions,
  position: 'absolute',
  height: '32px',
  width: '32px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center'
}

interface PlayerProps {
  playerTileRef?: React.Ref<HTMLUListElement>
  color?: string
  backgroundColor?: string
  tileSize?: number
  scrollMargin?: number
  y: number
  x: number
  spriteID?: string
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const Player = ({ playerTileRef, color = 'white', backgroundColor = 'transparent', scrollMargin = 96, tileSize = 32, y, x, spriteID}: PlayerProps) => (
  <Box ref={playerTileRef} sx={{ ...container, color, backgroundColor, height: `${tileSize}px`, width: `${tileSize}px`, top: `${y * tileSize}px`, left: `${x * tileSize}px`, scrollPadding: `${scrollMargin}px`, transform: `scale(${tileSize / 32})` }} className='player'>
      <SpotLight/>
      {
        spriteID ? (
          <Sprite spriteID={spriteID} />
        ) : (
          <span style={{ lineHeight: 1, fontSize: `${tileSize}px` }}>i</span>
        )
      }
    </Box>
)

export default Player
